import { useContext, useEffect, useState } from "react";
import { apiUrl, formatDate } from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import { useLocation, useNavigate } from "react-router-dom";

function DraftAffidavit() {
  const { activePage, token, profile, frequentData, setIsExpired } =
    useContext(ShareContext);
  const location = useLocation();

  const [loading, setLoading] = useState(false);
  const [draft, setDraft] = useState(null);
  const navigate = useNavigate();

  const role = location.pathname.includes("affidavits") ? "user" : "cfo";

  useEffect(() => {
    const fetchDraft = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${apiUrl}/filing/draft-affidavit`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          setDraft(data);
        }
        console.log(data);
      } catch (error) {
        console.error("Error fetching draft affidavit:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDraft();
  }, []);
  useEffect(() => {
    if (draft) {
      console.log("Draft Affidavit Data:", draft);
    }
  }, [draft]);
  if (loading) {
    return <BackLoader open={loading} />;
  }
  if (!draft) {
    return <div>No draft affidavits available.</div>;
  }

  const onView = (item) => {
    navigate(
      `/affidavit-prepare/${item.docUploadId}/${role}?amount=${item.amount}&ref=${item.id}&seal=${item.internalAmount}`
    );
  };

  return (
    <div>
      <div>
        <div>
          <div className="table-header">
            <p>Affidavit Draft</p>
          </div>
          <div className="table-wrapper ">
            <table className="case-details-table full-border">
              <thead>
                <tr>
                  {/* <th className="col-id">ID</th> */}

                  <th className="col-id">Id</th>
                  <th className="col-title"> Amount</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th className="col-action">Actions</th>
                </tr>
              </thead>
              <tbody>
                {draft.intpay.map((item, id) => {
                  return (
                    <tr key={id}>
                      <td>{item.id || "N/A"}</td>
                      <td>{item.amount || "N/A"}</td>
                      <td>{formatDate(item.createdOn) || "N/A"}</td>
                      <td>pending</td>
                      <td>
                        <JisButton variant="plain" onClick={() => onView(item)}>
                          Continue
                        </JisButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <BackLoader open={loading} />
    </div>
  );
}

export default DraftAffidavit;
